import unsafeWords from "../../../../data/unsafe_words.json";

export default (values) => {
  const errors = {};

  if (!values.month || values.month === "month") {
    errors.month = "Required";
  }

  if (!values.year || values.year === "year") {
    errors.year = "Required";
  }

  if (!values.card_exp) {
    errors.card_exp = "Required";
  }

  if (!values.amount) {
    errors.amount = "Required";
  } else if (values.amount < 1) {
    errors.amount = "Donation must be $1 or more";
  }

  return errors;
};

// needed to recursively check if there is an error in our form state
// this function may no longer be needed when redux forms bumps to v6
export function validateProps(obj) {
  function recurseProps(obj) {
    const keys = Object.keys(obj);

    if (keys.length > 0) {
      return keys.some((key) => {
        if (typeof obj[key] === "object") {
          return recurseProps(obj[key]);
        }

        return obj[key] === "Required";
      });
    }

    return false;
  }

  return recurseProps(obj);
}

export const phoneValid = (phone) => {
  return /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/.test(
    String(phone).toLowerCase(),
  );
};

export const emailValid = (value) => {
  return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value,
  );
};

export const emailValidation = (value) => {
  if (!value) {
    return "Required";
  } else if (!emailValid(value)) {
    return "Invalid email address";
  }
};

export const presenceValidation = (value) => (value ? undefined : "Required");
export const presenceCollectionValidation = (value) =>
  value && value.length > 0 ? undefined : "Required";
export const minDonationValue = (value) =>
  value < 1 ? "Must be at least $1.00" : undefined;

export const lengthValidation = (length) => (value) => {
  if (!value) return null;

  return value.length < length ? undefined : `Max character limit of ${length}`;
};

export const regionCheck = (value, allValues) => {
  const { address } = allValues;

  if (!address) return null;

  if (address.country == "United States" || address.country == "Canada") {
    return value ? null : "Required";
  }
};

export const safeDisplayName = (value) => {
  if (typeof value != "string") {
    return;
  }
  for (let i = 0; i < unsafeWords.length; i++) {
    if (value == unsafeWords[i]) {
      return "Invalid Display Name";
    }
  }
};
